
import React from "react";
import { DialogProps } from "./DialogProps";
import {
  Button, Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

export interface InformationDialogProps extends DialogProps<void> {
  title: string;
  body: string;
}

export default function InformationDialog(props: InformationDialogProps) {
  return (
    <>
      <Dialog open={true} fullScreen={false}>
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          {props.title}
        </DialogTitle>
        <DialogContent>
          {props.body}
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.closeDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
